export default __webpack_public_path__ + "static/proxima-nova-800-i-b316a66a9f59ff59292a9f963aa00a79.woff2";